var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inline-flex items-center space-x-1.5"},[_c('SiteUserProfileIcon',{attrs:{"width-class":"w-6","user":_vm.displayUser}}),_vm._v(" "),(!_vm.iconOnly)?_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.displayUser?.DisplayName ?? ''))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }